import { FunctionComponent, memo } from "react";
import { IProps } from "./navigation-group-header.types";
import { IconTitle } from "@edgetier/components";
import "./navigation-group-header.scss";
import classNames from "classnames";

/**
 * The header of group of navigation links. The style will change if the currently active page belongs to the group.
 * @param icon     The icon to display next to the title.
 * @param title    The title of the group.
 * @param isActive Whether the group is currently active.
 */
const NavigationGroupHeader: FunctionComponent<IProps> = ({ icon, title, isActive }) => {
    return (
        <div className={classNames("navigation-group-header", { "navigation-group-header--active": isActive })}>
            <IconTitle title={title} icon={icon} />
        </div>
    );
};

export default memo(NavigationGroupHeader);
